import palette from '../../styles/design-tokens.json';

export const DASHBOARD_DARK_COLORS = {
  canvas: '#071225',
  surface: '#0F1D31',
  border: '#27364D',
  textPrimary: '#F8FAFC',
  textSecondary: '#A6B2C3',
  textMuted: '#7E8CA0',
} as const;

export const DASHBOARD_CHART_COLORS = {
  leads: palette.primary,
  appointments: '#9B7BFF',
  attendance: '#22C7D6',
  sales: '#38C982',
} as const;

export const getDashboardThemeClasses = (isDark: boolean) => ({
  canvas: isDark
    ? 'bg-[#071225] text-[#F8FAFC]'
    : 'bg-[#F7F9FC] text-sminy-text-primary',
  surface: isDark
    ? 'border-[#27364D] bg-[#0F1D31]'
    : 'border-sminy-border bg-white',
  control: isDark
    ? 'border-[#27364D] bg-[#0F1D31] text-[#A6B2C3] hover:bg-[#27364D]/35 hover:text-[#F8FAFC]'
    : 'border-sminy-border bg-white text-sminy-text-secondary hover:bg-slate-50 hover:text-sminy-primary',
  input: isDark
    ? 'border-[#27364D] bg-[#0F1D31] text-[#F8FAFC]'
    : 'border-sminy-border bg-white text-sminy-text-primary',
  border: isDark ? 'border-[#27364D]' : 'border-sminy-border',
  divide: isDark ? 'divide-[#27364D]' : 'divide-sminy-border',
  primaryText: isDark ? 'text-[#F8FAFC]' : 'text-sminy-text-primary',
  secondaryText: isDark ? 'text-[#A6B2C3]' : 'text-sminy-text-secondary',
  mutedText: isDark ? 'text-[#7E8CA0]' : 'text-sminy-muted',
  accentText: isDark ? 'text-[#66A3FF]' : 'text-sminy-primary',
  accentSurface: isDark
    ? 'bg-sminy-primary/15 text-[#66A3FF]'
    : 'bg-sminy-blue-light text-sminy-primary',
  skeleton: isDark ? 'bg-[#27364D]/45' : 'bg-slate-200',
  track: isDark ? 'bg-[#27364D]/45' : 'bg-slate-100',
});
